import { render, staticRenderFns } from "./Liefengaccess.vue?vue&type=template&id=6d3222c6&scoped=true&"
import script from "./Liefengaccess.vue?vue&type=script&lang=js&"
export * from "./Liefengaccess.vue?vue&type=script&lang=js&"
import style0 from "./Liefengaccess.vue?vue&type=style&index=0&id=6d3222c6&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d3222c6",
  null
  
)

export default component.exports